import React, { useState, useEffect } from 'react'
import {
  Card,
  Form,
  Radio,
  RadioChangeEvent,
  Skeleton,
} from 'components/common'
import { useProductsQuery } from '../../../lib/graphql/storeadmin/types-and-hooks'
import { DiscountProductCard } from './DiscountProductCard'
import { DiscountAllowMultipleCard } from './DiscountAllowMultipleCard'

type Props = {
  form: any
  productId: string
  setProductId: React.Dispatch<React.SetStateAction<string>>
  canOverlap: boolean
  setCanOverlap: React.Dispatch<React.SetStateAction<boolean>>
  isEntire: boolean
  setIsEntire: React.Dispatch<React.SetStateAction<boolean>>
  isNew: boolean
}

type Option = {
  label: string
  value: string
}

export const DiscountTargetSelectionCard: React.FC<Props> = (props) => {
  const {
    form,
    productId,
    setProductId,
    canOverlap,
    setCanOverlap,
    isEntire,
    setIsEntire,
    isNew,
  } = props

  const { data, loading, error } = useProductsQuery({
    fetchPolicy: 'cache-and-network',
  })
  const [options, setOptions] = useState<Option[]>([])

  useEffect(() => {
    if (data) {
      // 対象施設の選択肢を作成
      const newOptions: Option[] = data.products.edges.map((product) => ({
        label: product.product.name.jaJp,
        value: product.product.id,
      }))
      setOptions(newOptions)
    }
  }, [data])

  useEffect(() => {
    // 全体 or 施設別を切り替えるたびにフォームの値を初期化する
    if (isEntire) {
      form.setFieldsValue({
        product: null,
        canOverlap: false,
      })
    } else {
      form.setFieldsValue({
        product: productId ? productId : options[0].value,
        canOverlap,
      })
    }
  }, [canOverlap, form, isEntire, options, productId])

  return (
    <Card>
      <Form.Item
        label="ディスカウントのカテゴリ"
        required={isNew}
        style={{ marginBottom: '8px' }}
      >
        {isNew ? (
          <Radio.Group
            value={isEntire}
            onChange={(e: RadioChangeEvent) => setIsEntire(e.target.value)}
          >
            <Radio value={true}>全体</Radio>
            <Radio value={false}>施設別</Radio>
          </Radio.Group>
        ) : (
          <>
            <Radio disabled={productId !== null} checked={!productId}>
              全体
            </Radio>
            <Radio disabled={!productId} checked={productId !== null}>
              施設別
            </Radio>
          </>
        )}
      </Form.Item>
      <div className="border-l-4 border shadow-sm p-8" hidden={isEntire}>
        <DiscountProductCard
          isNew={isNew}
          productId={productId}
          setProductId={setProductId}
          loading={loading}
          error={error}
          options={options}
        />
        <div className="h-8" />
        <DiscountAllowMultipleCard
          isNew={isNew}
          canOverlap={canOverlap}
          setCanOverlap={setCanOverlap}
        />
      </div>
    </Card>
  )
}
